const ProductType = Object.freeze({
  SUBSCRIPTION: 'subscription',
  CREDIT_PACKAGE: 'credit_package',
  TRIAL: 'trial',
} as const);

export type ProductType = (typeof ProductType)[keyof typeof ProductType];

export default ProductType;
